const keyProvisionsTemplate = `
<!DOCTYPE html>
<html>
  <head>  </head>
 
  <body>  
    <h2 class="pdf-table-heading">Key Provisions</h2>
      {{#if keyProvisionData.planningAdviser}}
      <div class="row">
      <!-- Key Contacts table-->
      <h3 class="pdf-table-sub-heading">Key Contacts</h3>
      <table id="print-pdf-table" class= "key-provision-table" style="page-break-inside: avoid;">
        <tr>
          <th></th>
          <th>Firm Name</th>
          <th>Key Contact</th>
          <th>Email</th>
          <th>Risk rating</th>
        </tr>
      {{else}}{{#if keyProvisionData.buildingContractors}}
      <div class="row">
      <!-- Key Contacts table-->
      <h2 class="pdf-table-heading">Key Contacts</h2>
      <table id="print-pdf-table" class= "key-provision-table" style="page-break-inside: avoid;">
        <tr>
          <th></th>
          <th>Firm Name</th>
          <th>Key Contact</th>
          <th>Email</th>
          <th>Risk rating</th>
        </tr>
      {{else}}{{#if keyProvisionData.leasingAgents}}
      <div class="row">
      <!-- Key Contacts table-->
      <h2 class="pdf-table-heading">Key Contacts</h2>
      <table id="print-pdf-table" class= "key-provision-table" style="page-break-inside: avoid;">
        <tr>
          <th></th>
          <th>Firm Name</th>
          <th>Key Contact</th>
          <th>Email</th>
          <th>Risk rating</th>
        </tr>
      {{else}}{{#if keyProvisionData.insuranceCompanyDetails}}
      <div class="row">
      <!-- Key Contacts table-->
      <h2 class="pdf-table-heading">Key Contacts</h2>
      <table id="print-pdf-table" class= "key-provision-table" style="page-break-inside: avoid;">
        <tr>
          <th></th>
          <th>Firm Name</th>
          <th>Key Contact</th>
          <th>Email</th>
          <th>Risk rating</th>
        </tr>
      {{else}}{{#if keyProvisionData.jvPartner}}
      <div class="row">
      <!-- Key Contacts table-->
      <h2 class="pdf-table-heading">Key Contacts</h2>
      <table id="print-pdf-table" class= "key-provision-table" style="page-break-inside: avoid;">
        <tr>
          <th></th>
          <th>Firm Name</th>
          <th>Key Contact</th>
          <th>Email</th>
          <th>Risk rating</th>
        </tr>
      {{/if}}{{/if}}{{/if}}{{/if}}{{/if}}
        {{#if keyProvisionData.planningAdviser}}
        <tr>
          <td>Planning Advisor</td>
          <td>{{{keyProvisionData.planningAdviser.firmName}}}</td>
          <td>{{{keyProvisionData.planningAdviser.keyContacts}}}</td>
          <td>{{{keyProvisionData.planningAdviser.email}}}</td>
          <td>{{{keyProvisionData.planningAdviser.riskRating}}}</td>
        </tr>
        {{/if}}
        {{#if keyProvisionData.buildingContractors}}
        <tr>
          <td>Building Contractors</td>
          <td>{{{keyProvisionData.buildingContractors.firmName}}}</td>
          <td>{{{keyProvisionData.buildingContractors.keyContacts}}}</td>
          <td>{{{keyProvisionData.buildingContractors.email}}}</td>
          <td>{{{keyProvisionData.buildingContractors.riskRating}}}</td>
        </tr>
        {{/if}}
        {{#if keyProvisionData.leasingAgents}}
        <tr>
          <td>Leasing agent(s)</td>
          <td>{{{keyProvisionData.leasingAgents.firmName}}}</td>
          <td>{{{keyProvisionData.leasingAgents.keyContacts}}}</td>
          <td>{{{keyProvisionData.leasingAgents.email}}}</td>
          <td>{{{keyProvisionData.leasingAgents.riskRating}}}</td>
        </tr>
        {{/if}}
        {{#if keyProvisionData.insuranceCompanyDetails}}
        <tr>
          <td>Insurance company details</td>
          <td>{{{keyProvisionData.insuranceCompanyDetails.firmName}}}</td>
          <td>{{{keyProvisionData.insuranceCompanyDetails.keyContacts}}}</td>
          <td>{{{keyProvisionData.insuranceCompanyDetails.email}}}</td>
          <td>{{{keyProvisionData.insuranceCompanyDetails.riskRating}}}</td>
        </tr>
        {{/if}}
        {{#each keyProvisionData.jvPartner}}
        <tr>
          <td>JV Partner {{add @index 1}}</td>
          <td>{{{this.firmName}}}</td>
          <td>{{{this.keyContacts}}}</td>
          <td>{{{this.email}}}</td>
          <td>{{{this.riskRating}}}</td>
        </tr>
        {{/each}}
      </table>
    </div>
    {{#if keyProvisionData.planningAdviser}}{{else}}{{#if keyProvisionData.buildingContractors}}{{else}}{{#if keyProvisionData.leasingAgents}}{{else}}{{#if keyProvisionData.insuranceCompanyDetails}}{{else}}{{#if keyProvisionData.jvPartner}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}
    <!-- Property Manager Detailed Section -->
    {{#if propertyType}}
   
    <div class="property-manager-section">
      <h3 class="pdf-table-sub-heading">Property Manager Assessment</h3>
      <table id="print-pdf-table" class="key-provision-table">
        <tr>
          <th colspan="2" style="background-color: #253746; color: white;">Property manager</th>
        </tr>
        <tr>
          <td colspan="2" style="font-style: italic; font-size: 0.75rem;">Please answer the following questions specific to the team working on your investment, not for the firm as a whole.</td>
        </tr>
        <tr>
          <td>Are you contemplating or have you started the RFP process to find a new PrM?</td>
          <td>{{{propertyType.rfpProcess}}}</td>
        </tr>
        <tr>
          <td>Would you work with them on another property?</td>
          <td>{{{propertyType.anotherProperty}}}</td>
        </tr>
        <tr>
          <td>Comments</td>
          <td>{{{propertyType.teamWorkingComments}}}</td>
        </tr>
        <tr>
          <td colspan="2" style="height: 20px;"></td>
        </tr>
        <tr>
          <td colspan="2" style="height: 15px; border-bottom: 1px solid #ddd;">&nbsp;</td>
        </tr>
        <tr>
          <td colspan="2" style="background-color: #f5f5f5;"><b>Rank the PrM on the topics below with 1 being the worst and 5 being the best.</b></td>
        </tr>
        <tr>
          <td>Responsive and transparent communication</td>
          <td>{{{propertyType.responsiveCommunication}}}</td>
        </tr>
        <tr>
          <td>Incident management</td>
          <td>{{{propertyType.incidentManager}}}</td>
        </tr>
        <tr>
          <td>Innovation and technology acumen</td>
          <td>{{{propertyType.innovationAndTech}}}</td>
        </tr>
        <tr>
          <td>Risk mitigation</td>
          <td>{{{propertyType.riskMitigation}}}</td>
        </tr>
        <tr>
          <td>Timely and accurate reporting</td>
          <td>{{{propertyType.timelyReporting}}}</td>
        </tr>
        <tr>
          <td>Tenant relations</td>
          <td>{{{propertyType.tenantRelations}}}</td>
        </tr>
        <tr>
          <td>Vendor selection and oversight</td>
          <td>{{{propertyType.vendorSelection}}}</td>
        </tr>
        <tr>
          <td>Comments</td>
          <td>{{{propertyType.prmRankComments}}}</td>
        </tr>
      </table>
    </div>
    {{/if}}
    <!-- JV Partner Detailed Section -->
    {{#if JVData}}
    <div class="Jvs model">
      <h3 class="pdf-table-sub-heading">JV Partner(s) Details</h3>
      {{#each JVData}}
      {{#unless @first}}
      <div style="page-break-before: always;"></div>
      {{/unless}}
      <table id="print-pdf-table" class="key-provision-table" style="margin-bottom: 30px;">
        <tr>
          <th colspan="2" style="background-color: #253746; color: white;">JV Partner {{add @index 1}}</th>
        </tr>
        <tr>
          <td colspan="2" style="font-style: italic; font-size: 0.75rem;">If the JV partner is also the PrM, ensure you complete the assessment of them as a PrM as well.</td>
        </tr>
        <tr>
          <td>Please list the JV partner firm</td>
          <td>{{{this.jvPartnerFirmName}}}</td>
        </tr>
        <tr>
          <td>Is this partner the developer?</td>
          <td>{{{this.isPartnerDeveloper}}}</td>
        </tr>
        <tr>
          <td>Would you work with this partner again?</td>
          <td>{{{this.willWorkWithJvPartnerAgain}}}</td>
        </tr>
        <tr>
          <td>Key Contact</td>
          <td>{{{this.keyContact}}}</td>
        </tr>
        <tr>
          <td>Email</td>
          <td>{{{this.email}}}</td>
        </tr>
        <tr>
          <td>Comments</td>
          <td>{{{this.comments}}}</td>
        </tr>
         <tr>
          <td colspan="2" style="height: 15px; border-bottom: 1px solid #ddd;">&nbsp;</td>
        </tr>
        <tr>
          <td colspan="2" style="background-color: #f5f5f5;"><b>Rank the JV partner on the topics below with 1 being the worst and 5 being the best.</b></td>

        </tr>
        <tr>
          <td>Responsiveness</td>
          <td>{{{this.responsiveness}}}</td>
        </tr>
        <tr>
          <td>Reporting</td>
          <td>{{{this.reporting}}}</td>
        </tr>
        <tr>
          <td>Flexibility</td>
          <td>{{{this.flexibility}}}</td>
        </tr>
        <tr>
          <td>Ethics</td>
          <td>{{{this.ethics}}}</td>
        </tr>
        <tr>
          <td>Communication</td>
          <td>{{{this.communication}}}</td>
        </tr>
        <tr>
          <td>Collaboration</td>
          <td>{{{this.collaboration}}}</td>
        </tr>
        <tr>
          <td>Comments</td>
          <td>{{{this.rankComments}}}</td>
        </tr>
        <tr>
          <td>Is the partner also the Property Manager?</td>
          <td>{{{this.isJvPartnerAlsoPrM}}}</td>
        </tr>
      </table>
      {{#unless @last}}
      <table style="width: 100%;">
        <tr><td style="height: 30px; border: none;">&nbsp;</td></tr>
      </table>
      {{/unless}}
      {{/each}}
    </div>
    {{/if}}

      {{#if keyProvisionData.holdingStructure.specialPurposeVehicle}}
      <div class="row">
      <!-- Holding Structure Section -->
      <h3 class="pdf-table-sub-heading">Holding Structure</h3>
      <table id="print-pdf-table" class= "key-provision-table">
        <tr>
          <th>Structure Type</th>
          <th>Details</th>
        </tr>
        {{#if keyProvisionData.holdingStructure.specialPurposeVehicle}}
        <tr>
          <td>Special purpose vehicle</td>
          <td>{{{keyProvisionData.holdingStructure.specialPurposeVehicle}}}</td>
        </tr>
        {{/if}}
        {{#if keyProvisionData.holdingStructure.holdingCompany}}
        <tr>
          <td>Holding company</td>
          <td>{{{keyProvisionData.holdingStructure.holdingCompany}}}</td>
        </tr>
        {{/if}}
      </table>
    </div>
    {{else}}{{#if keyProvisionData.holdingStructure.holdingCompany}}
      <div class="row">
      <!-- Holding Structure Section -->
      <h2 class="pdf-table-heading">Holding Structure</h2>
      <table id="print-pdf-table" class= "key-provision-table">
        <tr>
          <th>Structure Type</th>
          <th>Details</th>
        </tr>
        {{#if keyProvisionData.holdingStructure.specialPurposeVehicle}}
        <tr>
          <td>Special purpose vehicle</td>
          <td>{{{keyProvisionData.holdingStructure.specialPurposeVehicle}}}</td>
        </tr>
        {{/if}}
        {{#if keyProvisionData.holdingStructure.holdingCompany}}
        <tr>
          <td>Holding company</td>
          <td>{{{keyProvisionData.holdingStructure.holdingCompany}}}</td>
        </tr>
        {{/if}}
      </table>
    </div>
    {{/if}}{{/if}}

    <!-- Key Provision Section -->
<div>
    <table id="table-comment"> 
    {{#if KeyProvisionComment.mangementComment_date}}
    <tr><th><h3>Management Agreement:</h3></th></tr>
      <tr>
        <th>Name/ Parties/ Date</th>
      </tr>
      {{#if KeyProvisionComment.mangementComment_date}}
      <tr>
        <td>
        {{{KeyProvisionComment.mangementComment_date}}}
        </td>
      </tr>
      {{/if}}
      {{#if KeyProvisionComment.mangementComment_fee}}
      <tr>
        <th >Management Fees</th>
      </tr>
      <tr>
        <td>
        {{{KeyProvisionComment.mangementComment_fee}}}
        </td>
      </tr>
      {{/if}}
      {{#if KeyProvisionComment.mangementComment_otherFee}}
      <tr>
        <th>Other Fees</th>
      </tr>
      <tr>
        <td>
        {{{KeyProvisionComment.mangementComment_otherFee}}}
        </td>
      </tr>
      {{/if}}
    {{else}}{{#if KeyProvisionComment.mangementComment_fee}}
    <tr><th><h3>Management Agreement:</h3></th></tr>
      <tr>
        <th>Name/ Parties/ Date</th>
      </tr>
      {{#if KeyProvisionComment.mangementComment_date}}
      <tr>
        <td>
        {{{KeyProvisionComment.mangementComment_date}}}
        </td>
      </tr>
      {{/if}}
      {{#if KeyProvisionComment.mangementComment_fee}}
      <tr>
        <th >Management Fees</th>
      </tr>
      <tr>
        <td>
        {{{KeyProvisionComment.mangementComment_fee}}}
        </td>
      </tr>
      {{/if}}
      {{#if KeyProvisionComment.mangementComment_otherFee}}
      <tr>
        <th>Other Fees</th>
      </tr>
      <tr>
        <td>
        {{{KeyProvisionComment.mangementComment_otherFee}}}
        </td>
      </tr>
      {{/if}}
    {{else}}{{#if KeyProvisionComment.mangementComment_otherFee}}
    <tr><th><h3>Management Agreement:</h3></th></tr>
      <tr>
        <th>Name/ Parties/ Date</th>
      </tr>
      {{#if KeyProvisionComment.mangementComment_date}}
      <tr>
        <td>
        {{{KeyProvisionComment.mangementComment_date}}}
        </td>
      </tr>
      {{/if}}
      {{#if KeyProvisionComment.mangementComment_fee}}
      <tr>
        <th >Management Fees</th>
      </tr>
      <tr>
        <td>
        {{{KeyProvisionComment.mangementComment_fee}}}
        </td>
      </tr>
      {{/if}}
      {{#if KeyProvisionComment.mangementComment_otherFee}}
      <tr>
        <th>Other Fees</th>
      </tr>
      <tr>
        <td>
        {{{KeyProvisionComment.mangementComment_otherFee}}}
        </td>
      </tr>
      {{/if}}
    {{/if}}{{/if}}{{/if}}
      {{#if KeyProvisionComment.leasebroker_name}}
      <tr><th><h3>Leasing Broker:</h3></th></tr>
      <tr>
      <th style="text-align: left; padding: 5px">Name</th>
    </tr>
    {{#if KeyProvisionComment.leasebroker_name}}
    <tr>
      <td>
      {{{KeyProvisionComment.leasebroker_name}}}
      </td>
    </tr>
    {{/if}}
    {{#if KeyProvisionComment.leasebroker_fee}}
    <tr>
      <th>Management Fees</th>
    </tr>
    <tr>
      <td>
      {{{KeyProvisionComment.leasebroker_fee}}}
      </td>
    </tr>
    {{/if}}
    {{#if KeyProvisionComment.leasebroker_otherfee}}
    <tr>
      <th >Other Fees</th>
    </tr>
    <tr>
      <td>
      {{{KeyProvisionComment.leasebroker_otherfee}}}
      </td>
    </tr>
    {{/if}}
    {{else}}{{#if KeyProvisionComment.leasebroker_fee}}
      <tr><th><h3>Leasing Broker:</h3></th></tr>
      <tr>
      <th style="text-align: left; padding: 5px">Name</th>
    </tr>
    {{#if KeyProvisionComment.leasebroker_name}}
    <tr>
      <td>
      {{{KeyProvisionComment.leasebroker_name}}}
      </td>
    </tr>
    {{/if}}
    {{#if KeyProvisionComment.leasebroker_fee}}
    <tr>
      <th>Management Fees</th>
    </tr>
    <tr>
      <td>
      {{{KeyProvisionComment.leasebroker_fee}}}
      </td>
    </tr>
    {{/if}}
    {{#if KeyProvisionComment.leasebroker_otherfee}}
    <tr>
      <th >Other Fees</th>
    </tr>
    <tr>
      <td>
      {{{KeyProvisionComment.leasebroker_otherfee}}}
      </td>
    </tr>
    {{/if}}
    {{else}}{{#if KeyProvisionComment.leasebroker_otherfee}}
      <tr><th><h3>Leasing Broker:</h3></th></tr>
      <tr>
      <th style="text-align: left; padding: 5px">Name</th>
    </tr>
    {{#if KeyProvisionComment.leasebroker_name}}
    <tr>
      <td>
      {{{KeyProvisionComment.leasebroker_name}}}
      </td>
    </tr>
    {{/if}}
    {{#if KeyProvisionComment.leasebroker_fee}}
    <tr>
      <th>Management Fees</th>
    </tr>
    <tr>
      <td>
      {{{KeyProvisionComment.leasebroker_fee}}}
      </td>
    </tr>
    {{/if}}
    {{#if KeyProvisionComment.leasebroker_otherfee}}
    <tr>
      <th >Other Fees</th>
    </tr>
    <tr>
      <td>
      {{{KeyProvisionComment.leasebroker_otherfee}}}
      </td>
    </tr>
    {{/if}}
    {{/if}}{{/if}}{{/if}}
    {{#if KeyProvisionComment.jvagreement_KeyDecision}}
    <tr><th><h3>JV Agreement:</h3></th></tr>
    <tr>
    <th>Key Major Decisions</th>
  </tr>
  {{#if KeyProvisionComment.jvagreement_KeyDecision}}
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_KeyDecision}}}
    </td>
  </tr>
  {{/if}}
  {{#if KeyProvisionComment.jvagreement_fee}}
  <tr>
    <th>Fees</th>
  </tr>
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_fee}}}
    </td>
  </tr>
  {{/if}}
  {{#if KeyProvisionComment.jvagreement_liquidProvision}}
  <tr>
    <th>Liquidity Provisions</th>
  </tr>
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_liquidProvision}}}
    </td>
  </tr>
  {{/if}}
  {{#if KeyProvisionComment.jvagreement_Keyprovision}}
  <tr>
    <th>Other Key Provisions</th>
  </tr>
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_Keyprovision}}}
    </td>
  </tr>
  {{/if}}
  {{else}}{{#if KeyProvisionComment.jvagreement_fee}}
    <tr><th><h3>JV Agreement:</h3></th></tr>
    <tr>
    <th>Key Major Decisions</th>
  </tr>
  {{#if KeyProvisionComment.jvagreement_KeyDecision}}
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_KeyDecision}}}
    </td>
  </tr>
  {{/if}}
  {{#if KeyProvisionComment.jvagreement_fee}}
  <tr>
    <th>Fees</th>
  </tr>
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_fee}}}
    </td>
  </tr>
  {{/if}}
  {{#if KeyProvisionComment.jvagreement_liquidProvision}}
  <tr>
    <th>Liquidity Provisions</th>
  </tr>
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_liquidProvision}}}
    </td>
  </tr>
  {{/if}}
  {{#if KeyProvisionComment.jvagreement_Keyprovision}}
  <tr>
    <th>Other Key Provisions</th>
  </tr>
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_Keyprovision}}}
    </td>
  </tr>
  {{/if}}
  {{else}}{{#if KeyProvisionComment.jvagreement_liquidProvision}}
    <tr><th><h3>JV Agreement:</h3></th></tr>
    <tr>
    <th>Key Major Decisions</th>
  </tr>
  {{#if KeyProvisionComment.jvagreement_KeyDecision}}
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_KeyDecision}}}
    </td>
  </tr>
  {{/if}}
  {{#if KeyProvisionComment.jvagreement_fee}}
  <tr>
    <th>Fees</th>
  </tr>
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_fee}}}
    </td>
  </tr>
  {{/if}}
  {{#if KeyProvisionComment.jvagreement_liquidProvision}}
  <tr>
    <th>Liquidity Provisions</th>
  </tr>
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_liquidProvision}}}
    </td>
  </tr>
  {{/if}}
  {{#if KeyProvisionComment.jvagreement_Keyprovision}}
  <tr>
    <th>Other Key Provisions</th>
  </tr>
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_Keyprovision}}}
    </td>
  </tr>
  {{/if}}
  {{else}}{{#if KeyProvisionComment.jvagreement_Keyprovision}}
    <tr><th><h3>JV Agreement:</h3></th></tr>
    <tr>
    <th>Key Major Decisions</th>
  </tr>
  {{#if KeyProvisionComment.jvagreement_KeyDecision}}
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_KeyDecision}}}
    </td>
  </tr>
  {{/if}}
  {{#if KeyProvisionComment.jvagreement_fee}}
  <tr>
    <th>Fees</th>
  </tr>
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_fee}}}
    </td>
  </tr>
  {{/if}}
  {{#if KeyProvisionComment.jvagreement_liquidProvision}}
  <tr>
    <th>Liquidity Provisions</th>
  </tr>
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_liquidProvision}}}
    </td>
  </tr>
  {{/if}}
  {{#if KeyProvisionComment.jvagreement_Keyprovision}}
  <tr>
    <th>Other Key Provisions</th>
  </tr>
  <tr>
    <td>
    {{{KeyProvisionComment.jvagreement_Keyprovision}}}
    </td>
  </tr>
  {{/if}}
  {{/if}}{{/if}}{{/if}}{{/if}}
    </table>
    </div>



    {{#if KeyProvisionComment.mangementComment_date}}{{else}}{{#if KeyProvisionComment.mangementComment_fee}}{{else}}{{#if KeyProvisionComment.mangementComment_otherFee}}{{else}}{{#if KeyProvisionComment.leasebroker_name}}{{else}}{{#if KeyProvisionComment.leasebroker_fee}}{{else}}{{#if KeyProvisionComment.leasebroker_otherfee}}{{else}}{{#if KeyProvisionComment.jvagreement_KeyDecision}}{{else}}{{#if KeyProvisionComment.jvagreement_fee}}{{else}}{{#if KeyProvisionComment.jvagreement_liquidProvision}}{{else}}{{#if KeyProvisionComment.jvagreement_Keyprovision}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}{{/if}}
  </body>
  
</html>

`;

export default keyProvisionsTemplate;
